// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.recommendation-tile-wrapper {
  display: flex;
  gap: 24px;
  align-items: flex-start;
  padding: 0 16px;
}
.recommendation-tile-card {
  min-width: 400px;
  min-height: 210px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /*background: var(--color-grey-100);*/
  background: none;
}
.header {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 40px;
}
.cardTitle {
  font-weight: 700;
  font-size: 16px;
  line-height: 16px;
  color: var(--color-grey-45);
  color: var(--color-grey-45);
  margin-top: 0;
}
.cardDate {
  font-family: 'Source Sans Pro', sans-serif;
  font-weight: 400;
  font-size: 14px;
  margin-left: 8px;
}
.infoIcon {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  cursor: pointer;
}
.statsRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  gap: 16px;
}
.arrowBtn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  transition: background 0.2s;
}
.arrowBtn:disabled {
  cursor: not-allowed;
}
.statBlock {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
}
.statLabel {
  font-size: 14px;
}
.statValue {
  font-size: 32px;
  font-weight: 700;
}
.statUnit {
  font-size: 14px;
}
.feedbackRow {
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: space-between;
}
.selected {
  font-weight: 600;
}
.vertical-divider {
  width: 1px;
  height: 80px;
  /*background: #dce0e8;*/
  margin: 0 16px;
  align-self: center;
}
.feedbackBtn {
  background: none;
  border: none;
  padding: 6px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
  margin-left: 8px;
}
.feedbackBtn:first-of-type {
  margin-left: 16px;
}
.feedbackBtn.selected,
.feedbackBtn.focus-visible {
  background: var(--color-grey-96);
  background: var(--color-grey-96);
  box-shadow: 0 0 0 2px var(--color-primary-idel);
  box-shadow: 0 0 0 2px var(--color-primary-idel);
}
.feedbackBtn:hover:not(.selected) {
  background: var(--color-grey-98);
  background: var(--color-grey-98);
}
.feedbackBtn img {
  display: block;
}
.feedbackBtnLabel {
  margin-left: 6px;
  font-size: 14px;
  color: var(--color-grey-45);
  color: var(--color-grey-45);
  font-weight: 400;
  line-height: 1;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}
.feedback-row-wrapper {
  transition: opacity 0.3s;
  opacity: 0;
  height: 26px; /* Adjust to match the actual feedback row height */
  overflow: hidden;
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.feedback-row-wrapper.visible {
  opacity: 1;
  pointer-events: auto;
}
.feedback-row-figma {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 2px 0 0 8px;
  min-width: 400px;
  min-height: 26px;
}
.feedback-question-figma {
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: var(--color-grey-45);
  color: var(--color-grey-45);
  line-height: 1.1428571428571428em;
  text-align: left;
}
.feedback-btns-figma {
  display: flex;
  flex-direction: row;
  gap: 8px;
}
.feedback-btn-figma {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 24px;
  border-radius: 4px;
  border: none;
  background: none;
  cursor: pointer;
  padding: 0 12px 0 8px;
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: var(--color-grey-45);
  color: var(--color-grey-45);
  transition: background 0.2s;
  gap: 2px;
}
.feedback-btn-figma.selected,
.feedback-btn-figma.focus-visible {
  background: var(--color-grey-96);
  background: var(--color-grey-96);
  box-shadow: 0 0 0 2px var(--color-primary-idel);
  box-shadow: 0 0 0 2px var(--color-primary-idel);
}
.feedback-btn-figma:hover:not(.selected) {
  background: var(--color-grey-96);
  background: var(--color-grey-96);
}
.feedback-btn-label-figma {
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: var(--color-grey-45);
  color: var(--color-grey-45);
  line-height: 1.1428571428571428em;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}
.feedback-row-figma.thanks {
  justify-content: center;
}
.feedback-thanks-figma {
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: var(--color-grey-45);
  color: var(--color-grey-45);
  line-height: 1.1428571428571428em;
  text-align: center;
  width: 100%;
}
@media (max-width: 1560px) {
  .recommendation-tile-wrapper {
    height: 326px;
    min-height: 326px;
    max-height: 326px;
    padding-top: 16px;
    max-width: 400px;
  }
}
`, "",{"version":3,"sources":["webpack://./app/components/planning/IrrigationRecommendation/RecommendationTileWrapper.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,qCAAqC;EACrC,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAA3B,2BAA2B;EAC3B,aAAa;AACf;AACA;EACE,0CAA0C;EAC1C,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,OAAO;AACT;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,8BAA8B;AAChC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,gCAAgC;EAAhC,gCAAgC;EAChC,+CAA+C;EAA/C,+CAA+C;AACjD;AACA;EACE,gCAAgC;EAAhC,gCAAgC;AAClC;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAA3B,2BAA2B;EAC3B,gBAAgB;EAChB,cAAc;EACd,yBAAiB;KAAjB,sBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,wBAAwB;EACxB,UAAU;EACV,YAAY,EAAE,mDAAmD;EACjE,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAA3B,2BAA2B;EAC3B,iCAAiC;EACjC,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAA3B,2BAA2B;EAC3B,2BAA2B;EAC3B,QAAQ;AACV;AACA;;EAEE,gCAAgC;EAAhC,gCAAgC;EAChC,+CAA+C;EAA/C,+CAA+C;AACjD;AACA;EACE,gCAAgC;EAAhC,gCAAgC;AAClC;AACA;EACE,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAA3B,2BAA2B;EAC3B,iCAAiC;EACjC,yBAAiB;KAAjB,sBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAA3B,2BAA2B;EAC3B,iCAAiC;EACjC,kBAAkB;EAClB,WAAW;AACb;AACA;EACE;IACE,aAAa;IACb,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;EAClB;AACF","sourcesContent":[".recommendation-tile-wrapper {\n  display: flex;\n  gap: 24px;\n  align-items: flex-start;\n  padding: 0 16px;\n}\n.recommendation-tile-card {\n  min-width: 400px;\n  min-height: 210px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  /*background: var(--color-grey-100);*/\n  background: none;\n}\n.header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  height: 40px;\n}\n.cardTitle {\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 16px;\n  color: var(--color-grey-45);\n  margin-top: 0;\n}\n.cardDate {\n  font-family: 'Source Sans Pro', sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  margin-left: 8px;\n}\n.infoIcon {\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  cursor: pointer;\n}\n.statsRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 24px;\n  gap: 16px;\n}\n.arrowBtn {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  padding: 8px;\n  border-radius: 50%;\n  transition: background 0.2s;\n}\n.arrowBtn:disabled {\n  cursor: not-allowed;\n}\n.statBlock {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex: 1;\n}\n.statLabel {\n  font-size: 14px;\n}\n.statValue {\n  font-size: 32px;\n  font-weight: 700;\n}\n.statUnit {\n  font-size: 14px;\n}\n.feedbackRow {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  justify-content: space-between;\n}\n.selected {\n  font-weight: 600;\n}\n.vertical-divider {\n  width: 1px;\n  height: 80px;\n  /*background: #dce0e8;*/\n  margin: 0 16px;\n  align-self: center;\n}\n.feedbackBtn {\n  background: none;\n  border: none;\n  padding: 6px;\n  border-radius: 50%;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.2s;\n  margin-left: 8px;\n}\n.feedbackBtn:first-of-type {\n  margin-left: 16px;\n}\n.feedbackBtn.selected,\n.feedbackBtn:focus-visible {\n  background: var(--color-grey-96);\n  box-shadow: 0 0 0 2px var(--color-primary-idel);\n}\n.feedbackBtn:hover:not(.selected) {\n  background: var(--color-grey-98);\n}\n.feedbackBtn img {\n  display: block;\n}\n.feedbackBtnLabel {\n  margin-left: 6px;\n  font-size: 14px;\n  color: var(--color-grey-45);\n  font-weight: 400;\n  line-height: 1;\n  user-select: none;\n}\n.feedback-row-wrapper {\n  transition: opacity 0.3s;\n  opacity: 0;\n  height: 26px; /* Adjust to match the actual feedback row height */\n  overflow: hidden;\n  pointer-events: none;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n.feedback-row-wrapper.visible {\n  opacity: 1;\n  pointer-events: auto;\n}\n.feedback-row-figma {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 2px 0 0 8px;\n  min-width: 400px;\n  min-height: 26px;\n}\n.feedback-question-figma {\n  font-family: 'Source Sans Pro', sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  color: var(--color-grey-45);\n  line-height: 1.1428571428571428em;\n  text-align: left;\n}\n.feedback-btns-figma {\n  display: flex;\n  flex-direction: row;\n  gap: 8px;\n}\n.feedback-btn-figma {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  height: 24px;\n  border-radius: 4px;\n  border: none;\n  background: none;\n  cursor: pointer;\n  padding: 0 12px 0 8px;\n  font-family: 'Source Sans Pro', sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--color-grey-45);\n  transition: background 0.2s;\n  gap: 2px;\n}\n.feedback-btn-figma.selected,\n.feedback-btn-figma:focus-visible {\n  background: var(--color-grey-96);\n  box-shadow: 0 0 0 2px var(--color-primary-idel);\n}\n.feedback-btn-figma:hover:not(.selected) {\n  background: var(--color-grey-96);\n}\n.feedback-btn-label-figma {\n  font-family: 'Source Sans Pro', sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--color-grey-45);\n  line-height: 1.1428571428571428em;\n  user-select: none;\n}\n.feedback-row-figma.thanks {\n  justify-content: center;\n}\n.feedback-thanks-figma {\n  font-family: 'Source Sans Pro', sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  color: var(--color-grey-45);\n  line-height: 1.1428571428571428em;\n  text-align: center;\n  width: 100%;\n}\n@media (max-width: 1560px) {\n  .recommendation-tile-wrapper {\n    height: 326px;\n    min-height: 326px;\n    max-height: 326px;\n    padding-top: 16px;\n    max-width: 400px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
